export default __webpack_public_path__ + "static/N0070-ec58e77e9c3696ebb696531f8dc2ff87.png";